import { TripStop } from '../types/trip';

export interface StoredTrip {
  id: string;
  name: string;
  createdAt: string;
  routeName?: string;
  startPoint?: string;
  endPoint?: string;
  routeKey?: string;
  stops: TripStop[];
}

const STORAGE_KEY = 'trip-planner.savedTrips';
const ACTIVE_TRIP_KEY = 'trip-planner.activeTrip';

const isBrowser = () => typeof window !== 'undefined';

export function loadSavedTrips(): StoredTrip[] {
  if (!isBrowser()) return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as StoredTrip[];
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
}

export function persistTrips(trips: StoredTrip[]): void {
  if (!isBrowser()) return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trips));
}

export function upsertTrip(trip: StoredTrip): StoredTrip[] {
  const trips = loadSavedTrips();
  const index = trips.findIndex((item) => item.id === trip.id);
  if (index >= 0) {
    trips[index] = trip;
  } else {
    trips.unshift(trip);
  }
  persistTrips(trips);
  return trips;
}

export function deleteTrip(tripId: string): StoredTrip[] {
  const trips = loadSavedTrips().filter((trip) => trip.id !== tripId);
  persistTrips(trips);
  return trips;
}

export function saveActiveTripDraft(trip: StoredTrip | null): void {
  if (!isBrowser()) return;
  if (!trip) {
    window.localStorage.removeItem(ACTIVE_TRIP_KEY);
    return;
  }
  window.localStorage.setItem(ACTIVE_TRIP_KEY, JSON.stringify(trip));
}

export function loadActiveTripDraft(): StoredTrip | null {
  if (!isBrowser()) return null;
  const raw = window.localStorage.getItem(ACTIVE_TRIP_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as StoredTrip;
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}
